export default "<app-openings></app-openings>\n<app-testimonials></app-testimonials>"